<section id="about">
  <div class="container who-we-are">
    <div class="row">
      <div class="col-sm-8 offset-sm-2">
        <div class="center-heading">
          <h2>¿Qué es e-cclesia?</h2>
          <span class="center-line"></span>
          <p class="sub-text margin40">
            Es un programa de gestión administrativa parroquial, E-cclesia es un software que ayuda
            a las parroquias y sacerdotes a tener su información administrativa y su archivo
            parroquial informatizado y disponible desde cualquier ordenador o dispositivo
            electrónico, que cuente con internet.
            <br />
            A través de la plataforma, los usuarios pueden acceder en tiempo real a datos, reportes
            y registros, lo que optimiza la toma de decisiones, mejora la transparencia en la
            administración y agiliza los procesos internos. <br />E-cclesia es utilizada en la
            actualidad por varias parroquias.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
